import type { ICircuitEditorModel, ICircuitModel } from '@/interfaces/models';
import { CircuitEditorModel } from '@/models/CircuitEditorModel';
import { HistoryModel } from '@/models/HistoryModel';

export class CircuitEditorModelFactory {
  create(circuitModel: ICircuitModel): ICircuitEditorModel {
    return new CircuitEditorModel(circuitModel, new HistoryModel());
  }
}
